import { render, staticRenderFns } from "./AfterSurvey.vue?vue&type=template&id=7163f5db&scoped=true&"
import script from "./AfterSurvey.vue?vue&type=script&lang=js&"
export * from "./AfterSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7163f5db",
  null
  
)

export default component.exports